import { FC, memo, useCallback } from 'react'
import { useField } from 'react-final-form'
import { FormItem } from '@cargomart/ui'
import { useNavigate } from '@tanstack/react-router'
import ModalItem from 'components/ModalItem'
import { MODAL_IDS, useModal } from 'components/ModalProvider'
import { FieldRadio } from 'forms/FieldRadio'
import { OrderCargoInfo, OrderCargoServiceType } from 'schema'

import OrderServiceTypeInfo from '../OrderServiceTypeInfo/OrderServiceTypeInfo'
import { OrderCargoHeightLimitWarning } from './warnings/OrderCargoHeightLimitWarning'
import { OrderCargoLengthLimitWarning } from './OrderCargoLengthLimitWarning'
import { OrderCargoSeparate } from './OrderCargoSeparate'
import { OrderCargoTotal } from './OrderCargoTotal'

interface OrderCargoBlockFormProps {
  className?: string
}

const OrderCargoBlockForm: FC<OrderCargoBlockFormProps> = (props) => {
  const { className } = props
  const navigate = useNavigate()

  const {
    input: { value }
  } = useField<OrderCargoInfo.type>('cargoType')

  const { openModal, closeModal } = useModal()

  const handleCloseCustom = () => {
    closeModal(MODAL_IDS.OrderServiceTypeInfoCreate)
  }
  const handleOpenCustom = useCallback(() => {
    openModal(MODAL_IDS.OrderServiceTypeInfoCreate)
    navigate({ hash: OrderCargoServiceType.Id.CUSTOM })
  }, [openModal, navigate])
  const handleOpenPallet = useCallback(() => {
    openModal(MODAL_IDS.OrderServiceTypeInfoCreate)
    navigate({ hash: OrderCargoServiceType.Id.PALLET })
  }, [openModal, navigate])

  return (
    <div className={className}>
      <div className="mb-3 mt-4 text-headline-sm">Груз</div>
      <FormItem className="inline-flex flex-col gap-y-1">
        <FieldRadio name="cargoType" value={OrderCargoInfo.type.SEPARATE}>
          Отдельными грузоместами
        </FieldRadio>
        <FieldRadio name="cargoType" value={OrderCargoInfo.type.TOTAL}>
          Общий вес и объём
        </FieldRadio>
      </FormItem>
      {value === OrderCargoInfo.type.SEPARATE && (
        <OrderCargoSeparate onOpenCustomScheduler={handleOpenCustom} onOpenPalletScheduler={handleOpenPallet} />
      )}
      {value === OrderCargoInfo.type.TOTAL && <OrderCargoTotal onOpenScheduler={handleOpenCustom} />}
      <OrderCargoHeightLimitWarning />
      <OrderCargoLengthLimitWarning />
      <ModalItem id={MODAL_IDS.OrderServiceTypeInfoCreate}>
        <OrderServiceTypeInfo handleClose={handleCloseCustom} id={MODAL_IDS.OrderServiceTypeInfoCreate} />
      </ModalItem>
    </div>
  )
}

export default memo(OrderCargoBlockForm)
